<section class="container">
  <div class="mb-3 row">
    <div class="col">
      <h3>Crédito Livre</h3>
    </div>
    <div class="col-auto">
      <button class="btn btn-primary" *ngIf="permissaoGestorEnvio" (click)="abrirModal('Modal com body sendo uma template', 'lg', true, true);"><i
          class="fa fa-file-signature">
        </i> Incluir natureza de crédito livre</button>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th id="col-nome" scope="col">
            <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nome'" [nomeAtributoExibicao]="'Nome'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>
          <th id="col-restricaoTipoPessoa" scope="col">
            <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'restricaoTipoPessoa'" [nomeAtributoExibicao]="'Restrição'"
              (aoClickar)="mudancaOrdenacao($event)">
            </bn-ordenacao>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of creditoLivre">
          <td>{{item.nome}}</td>
          <td>{{item.restricaoTipoPessoa}}</td>
          <td class="text-start" *ngIf="permissaoGestorEnvio" id=col-acoes><a href="javascript:void(0)" bnConfirm tituloConfirm="Confirmação"
              msgConfirm="Tem certeza de que deseja excluir a natureza de crédito livre?"
              (onConfirm)="excluiCreditoLivre(item.id)">
              <i class="fa fa-trash" aria-hidden="true" placement="left-top"
                ngbTooltip="Excluir natureza de crédito livre">
              </i></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<ng-template #body>
  <div class="container">
    <div class="row">
      <div class="col">
      </div>
    </div>
    <div class="bn-form-group row">
      <div class="bn-form-group col-md-12">
        <label for="nome">Nome:</label>
        <select id="nome" class="form-select" [(ngModel)]="idNatureza">
          <option [ngValue]="natureza.id" *ngFor="let natureza of dadosDominio.naturezas">{{ natureza.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-6">
        <label for="restricao">Restrição por Tipo de Pessoa: <i class="fa fa-question-circle help-subtitulo" placement="top-right" 
          ngbTooltip="A opção 'Não há' significa que a natureza será permitida tanto para Pessoa Jurídica quanto para Pessoa Física."></i></label>
        <select id="restricao" class="form-select" [(ngModel)]="idRestricao">
          <option value="" >Não há</option>
          <option value="J">Apenas PJ</option>
          <option value="F">Apenas PF</option>
        </select>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #botoes>
  <button class="btn btn-danger" (click)="close()">Fechar</button>
  <button class="btn btn-success" (click)="salvar()">Salvar</button>
</ng-template>